import { render, staticRenderFns } from "./AreaPicker.vue?vue&type=template&id=70ddc78c&lang=pug&"
import script from "./AreaPicker.vue?vue&type=script&lang=js&"
export * from "./AreaPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports